import consumer from "./consumer"
import bootbox from 'bootbox/bootbox';
import $ from "jquery";

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
}


document.addEventListener('turbo:load', () => {
    if (location.pathname.includes('commercial/rooms/')) {
        const room_element = document.getElementById('room_id')
        const room_id = Number(room_element.getAttribute('data-room-id'))
        const messageContainer = document.getElementById('message_container')
        const user_element = document.getElementById('user_id')
        const user_id = Number(user_element.getAttribute('data-user-id'))
        const is_commercial = (user_element.getAttribute('data-commercial') === 'true');
        const commercial_id = Number(user_element.getAttribute('data-commercial-id'))
        let room_message_message = document.getElementById('room_message_message')
        const chat_status = document.getElementById('chat_status')
        const reciever_id = document.getElementById('room_message_reciever_id').value

        //FORMULARIO DE ENVIO DE MENSAJES
        const form = document.getElementById('new_room_message')
        // const form = document.getElementById('formMessage')
        const input_message = document.getElementById('room_message_message')
        const submitMessageBtn = document.getElementById('submitMessageBtn')
        // const submitMessageBtn = $('#submitMessageBtn')

        let timeout;
        sessionStorage.setItem('user_id', user_id);
        sessionStorage.setItem('is_commercial', is_commercial);
        sessionStorage.setItem('receiver_id', reciever_id);
        sessionStorage.setItem('chat_room', room_id);

        submitMessageBtn.addEventListener('click', (e) => {
            if (input_message.value === '') {
                e.stopPropagation();
                e.preventDefault();
            } else {
                if (sessionStorage.getItem("chat_room")) {
                    $.ajax({
                        url: `${location.origin}/room_message/create`,
                        data: {
                            room_message: {
                                message: input_message.value,
                                room_id: room_id,
                                reciever_id: reciever_id
                            }
                        },
                        type: 'POST',
                        success: function (response) {
                            input_message.value = '';
                        }
                    })
                }
            }
        })

        const chat_room = consumer.subscriptions.create({channel: "RoomChannel", room_id: room_id}, {
            connected() {

                messageContainer.scrollTo(0, messageContainer.scrollHeight);

                const ignoredKeys = ["Enter", "Alt", "Shift", "Backspace", "Control", "Meta", "Tab", "CapsLock"];

                room_message_message.addEventListener('keyup', function (e) {

                    if (e.key === "Enter") {
                        if (input_message.value.trim() !== "") {
                            submitMessageBtn.click();
                        } else {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }else{
                        if (!ignoredKeys.includes(e.key)) {
                            sendMessage({
                                type: 'typing',
                                message: 'Escribiendo',
                                code: e.key
                            })
                        }
                    }
                });

                document.getElementById('get_info_user').addEventListener('click', function () {
                    sendMessage({type: 'request_info'})
                });

                document.getElementById('terminate_assistance').addEventListener('click', function () {
                    sendMessage({type: 'terminate'})
                });

                function sendMessage(data) {
                    chat_room.send({
                        ...data,
                        room_id: Number(room_id),
                        from: user_id,
                        to: reciever_id
                    });
                }

            },

            disconnected() {
                consumer.subscriptions.remove(chat_room);

                window.addEventListener('beforeunload', function () {
                    chat_room.unsubscribe();
                });
            },

            received(data) {

                switch (data['type']) {
                    case "typing":
                        if (parseInt(user_id) === parseInt(data['to'])) {
                            if (data['code'] === "Enter" || data['code'] === "Alt" || data['code'] === "Shift" || data['code'] === "Backspace") {
                                chat_status.style.bottom = '0';
                            } else {
                                chat_status.style.bottom = '70px';
                            }
                            clearTimeout(timeout);
                            timeout = setTimeout(function () {
                                chat_status.style.bottom = '0';
                            }, 1000);
                        }

                        break;
                    case "request_info":
                        console.log("")
                        break;
                    case "info":
                        if (parseInt(user_id) === parseInt(data['to'])) {
                            messageContainer.innerHTML += data['message']
                            messageContainer.scrollTo(0, messageContainer.scrollHeight);
                        }
                        break;
                    case "terminate":
                        if (parseInt(user_id) === parseInt(data['from'])) {
                            messageContainer.innerHTML += data['message']
                            messageContainer.scrollTo(0, messageContainer.scrollHeight);
                        }
                        break;
                    case "connecting":
                        let indicator = document.getElementById('user_status');
                        let text = document.getElementById('user_status_text');
                        let buttons =  document.getElementById('button-action');

                        if (data['status'] === true) {
                            indicator.classList.remove('text-muted');
                            text.innerText = 'Conectado';
                            indicator.classList.add('text-success');
                            buttons.style.display = 'inline';
                        }else{
                            indicator.classList.add('text-muted');
                            text.innerText = 'No conectado';
                            indicator.classList.remove('text-success');
                            buttons.style.display = 'inline';
                        }

                        break;
                    case "message":
                        input_message.value = '';

                        const client_id = document.getElementById('user_id').dataset['clientId']
                        if (parseInt(user_id) === parseInt(data['message'].user_id) || parseInt(user_id) === parseInt(data['message'].reciever_id)) {
                            let html = (parseInt(user_id) === parseInt(data['message'].user_id))
                                ? data['mine']
                                : data['theirs'];

                            if(parseInt(data['message'].user_id) === parseInt(client_id) || parseInt(data['message'].user_id) === parseInt(user_id)){
                                messageContainer.innerHTML += html
                                messageContainer.scrollTo(0, messageContainer.scrollHeight);
                            }
                        }

                        break;
                    default:
                        console.log("")
                }
             }
        })


        // const channel_room = consumer.subscriptions.create({channel: "RoomChannel", room_id: room_id}, {
        //     connected() {
        //         console.log("Conectado al chat admin");
        //         //AL iniciar ubicar el area de mensajes en el ultimo enviado si es que existe
        //         messageContainer.scrollTo(0, messageContainer.scrollHeight);
        //         //Al presionar cualquier tecla, notificar al otro usuario que se esta ecribiendo un mensaje
        //
        //         const ignoredKeys = ["Enter", "Alt", "Shift", "Backspace", "Control", "Meta", "Tab", "CapsLock"];
        //         room_message_message.addEventListener('keydown', function (e) {
        //             if (e.key === "Enter") {
        //                 if (input_message.value.trim() !== "") {
        //                     submitMessageBtn.dispatchEvent(new Event('click'));
        //                     input_message.value = ''
        //                 } else {
        //                     e.stopPropagation();
        //                     e.preventDefault();
        //
        //                 }
        //
        //             }
        //
        //             if (!ignoredKeys.includes(e.key)) {
        //                 sendMessage({
        //                     type: 'typing',
        //                     message: 'Escribiendo',
        //                     code: e.key
        //                 })
        //                 // channel_room.send({
        //                 //     type: 'typing',
        //                 //     message: 'Escribiendo',
        //                 //     room_id: room_id,
        //                 //     from: user_id,
        //                 //     to: reciever_id,
        //                 //     code: e.key
        //                 // })
        //             }
        //
        //
        //         });
        //
        //         function sendMessage(data){
        //             channel_room.send({
        //                 ...data,
        //                 room_id: Number(room_id),
        //                 from: user_id,
        //                 to: reciever_id
        //             });
        //         }
        //
        //         // Called when the subscription is ready for use on the server
        //
        //         //PARA SOLICITAR DATOS DE USUARIO Y TERMINAR LA CONVERSACION
        //         document.getElementById('get_info_user').addEventListener('click',function () {
        //             sendMessage({type: 'request_info'})
        //             // channel_room.send({
        //             //     type: 'request_info',
        //             //     room_id: Number(room_id),
        //             //     from: user_id,
        //             //     to: reciever_id
        //             // })
        //         })
        //
        //         document.getElementById('terminate_assistance').addEventListener('click', function () {
        //             sendMessage({type: 'terminate'})
        //             // channel_room.send({
        //             //     type: 'terminate',
        //             //     room_id: Number(room_id),
        //             //     from: user_id,
        //             //     to: reciever_id
        //             // })
        //         })
        //     },
        //
        //     disconnected() {
        //         // consumer.disconnect();
        //         consumer.subscriptions.remove(channel_room);
        //         window.addEventListener('beforeunload', function () {
        //             channel_room.unsubscribe();
        //             console.log("Desconectado del chat");
        //         });
        //     },
        //
        //     received(data) {
        //         // Called when there's incoming data on the websocket for this channel
        //         console.log(data)
        //         switch (data.type) {
        //             case 'connecting':
        //                 if (parseInt(user_id) === parseInt(data.to)){
        //                     let indicator = document.getElementById('user_status');
        //                     let text = document.getElementById('user_status_text');
        //                     let buttons =  document.getElementById('button-action');
        //                     if(data.status === true){
        //                         indicator.classList.remove('text-muted');
        //                         text.innerText = 'Conectado';
        //                         indicator.classList.add('text-success');
        //                         buttons.style.display = 'inline';
        //                     }else{
        //                         indicator.classList.add('text-muted');
        //                         text.innerText = 'No conectado';
        //                         indicator.classList.remove('text-success');
        //                         buttons.style.display = 'inline';
        //                     }
        //                 }
        //                 break
        //             case 'message':
        //                 //Para que no se mesclen los mensajes de una conversacion con otra
        //                 input_message.value = '';
        //
        //                 if (parseInt(user_id) === parseInt(data.message.user_id) || parseInt(user_id) === parseInt(data.message.reciever_id)) {
        //                     // let html;
        //                     // if (parseInt(user_id) === parseInt(data.message.user_id)) {
        //                     //     html = data.mine;
        //                     // } else {
        //                     //     html = data.theirs;
        //                     // }
        //
        //                     let html = (parseInt(user_id) === parseInt(data.message.user_id))
        //                         ? data.mine
        //                         : data.theirs;
        //
        //                     messageContainer.innerHTML += html
        //                     messageContainer.scrollTo(0, messageContainer.scrollHeight);
        //                 }
        //
        //                 break;
        //             case 'typing':
        //                 if (parseInt(user_id) === parseInt(data.to)) {
        //                     if (data.code === "Enter" || data.code === "Alt" || data.code === "Shift" || data.code === "Backspace") {
        //                         chat_status.style.bottom = '0';
        //                     } else {
        //                         chat_status.style.bottom = '60px';
        //                     }
        //                     clearTimeout(timeout);
        //                     timeout = setTimeout(function () {
        //                         chat_status.style.bottom = '0';
        //                     }, 2000);
        //                 }
        //                 break
        //             case 'info':
        //                 if (parseInt(user_id) === parseInt(data.to)) {
        //                     messageContainer.innerHTML += data.message
        //                     messageContainer.scrollTo(0, messageContainer.scrollHeight);
        //                 }
        //                 break
        //         }
        //
        //     },
        // });

        //FUNC. PARA CREAR O CONECTARSE A UNA SUBC. DE EL CHAT DE ASISTENCIA
        // function createChannelSubscription() {
        //     consumer.subscriptions.subscribe(chat_room);
        // }

        window.addEventListener('beforeunload', function () {
            const navigationEntry = performance.getEntriesByType("navigation")[0];
            const csrf = document.querySelector('meta[name="csrf-token"]').content;
            const tabCount = parseInt(localStorage.getItem("tabCount"))
            if (navigationEntry && navigationEntry.type === "reload") {
                consumer.subscriptions.remove(chat_room);
                consumer.subscriptions.subscribe(chat_room);
            } else {
                if (tabCount === 1) {
                    consumer.subscriptions.remove(chat_room);
                    consumer.disconnect();

                    // jQuery.ajax({
                    //     type: "GET",
                    //     headers: {'X-CSRF-Token': csrf},
                    //     contentType: "application/x-www-form-urlencoded",
                    //     url: `${location.origin}/${sessionStorage.getItem('locale')}/logout`,
                    //     data: {},
                    //     success: function (res){
                    //     },
                    //     error: function (res){
                    //     }
                    // })
                } else {
                    console.log("");
                }
            }
            // channel_room.unsubscribe();
        });

        // FUNC. PARA SI NO HAY VISIBILIDAD DESCONECTE CABLE
        // document.addEventListener("visibilitychange", function () {
        //     if (document.visibilityState === "visible") {
        //         createChannelSubscription();
        //     } else {
        //         // channel_room.unsubscribe();
        //         consumer.subscriptions.remove(chat_room)
        //     }
        // });

    }
    // else {
    //     if (sessionStorage.getItem('is_commercial') === 'false') {
    //          sessionStorage.removeItem('receiver_id');
    //         sessionStorage.removeItem('user_id');
    //         sessionStorage.removeItem('is_commercial');
    //         sessionStorage.removeItem('chat_room');
    //
    //         consumer.subscriptions.subscriptions.forEach(subscription => {
    //             consumer.subscriptions.remove(subscription);
    //         })
    //     }
    // }

})


